import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";
import { jsonToQuery } from "@/utils/queryHelper";

/**
 * Ferry Basic Service
 * Temel feribot API'leri için servis
 */
export const ferryBasicService = {
  /**
   * Sayfa tipini belirle
   * @param {Array} queries - URL segment'leri (örn: {slug: "yenikapi-bursa"})
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Usage Examples:
   * decidePageType({ slug: "yenikapi-bursa" })
   * → GET /decidePageType?slug=yenikapi-bursa
   */
  decidePageType: (query = {}, headers = {}, hasErrorHandler = false) => {
    return request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.basic.decidePageType}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    });
  },

  /**
   * Tüm kampanyaları getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr"
   * }
   */
  getAllCampaigns: (query = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.basic.getAllCampaigns}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  /**
   * Tüm ayrıcalıkları getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr"
   * }
   */
  getAllPrivileges: (query = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.basic.getAllPrivileges}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  /**
   * Blog yazılarını getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.ClientChannel - İstemci kanalı (örn: "web", "mobile")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "ClientChannel": "web"
   * }
   */
  getBlog: (query = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.basic.getBlog}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  /**
   * Sık sorulan soruları getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CurrencyCode": "TRY"
   * }
   */
  getSss: (query = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.basic.getSss}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  getListCampaigns: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.basic.getListCampaigns}?${jsonToQuery(payload)}`,
      headers,
      hasErrorHandler,
    }),
};
